import { useMutation } from '@tanstack/react-query'
import { validateReference } from 'services/WalletsService'

export const useValidateReferenceWithdrawalMutation = () => {
  return useMutation({ mutationFn: validateReference })
}
